<template>
  <sc-page>
    <div class="index-box">
      <div class="form-field">
        <div class="label">请输入每条线路需要绑定的设备数</div>
        <a-input class="input" type="number" v-model:value="num" />
      </div>
      <div class="form-field">
        <div class="label">请选择需要绑定的设备</div>
        <select-model-table
          module-name="management"
          controller-name="device"
          label-name="name"
          input-label=""
          :hidden-fields="['rule', 'selectedProxy', 'proxySetting']"
          v-model="options"
        />
      </div>
    </div>
    <div class="form-btn-group">
      <sc-btn :handler="onSubmit" text="确定" type="primary" />
      <sc-btn :handler="onReset" style="margin-left: 10px" text="重置" />
    </div>
  </sc-page>
</template>
<script lang="ts" setup>
import { inject, ref } from 'vue';
import { WindowTool } from '@/components/common/window/WindowInterface';
import SelectModelTable from '@/components/business/crud/common/SelectModelTable.vue';

const num = ref(1);

const options = ref([]);

const windowTool = inject<WindowTool | false>(WindowTool, false);

async function onSubmit() {
  if (windowTool) {
    windowTool.close({
      selected: options.value,
      num: num.value,
    });
  }
}

function onReset() {
  options.value = [];
}
</script>

<style lang="scss" scoped>
.index-box {
  flex-grow: 1;
  overflow: auto;
  padding: 0 10px 10px;
}

.form-field {
  padding: 16px 16px 0;

  .label {
    padding-bottom: 16px;
  }

  .input {
    width: 300px;
  }
}

.form-btn-group {
  border-top: 1px solid $color-content-border;
  padding: $spacing-medium;

  .select-form {
    margin-bottom: $spacing-medium;

    .select-row {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: $spacing-medium;

      .select-label {
        margin-right: $spacing-medium;
      }

      .select {
        width: 80%;
      }
    }
  }
}
</style>
